import { Category as CategoryType } from "@common/types/category";
import { mapCategoryName, TransactionDirectionType } from "@common/categories";

export function isCategoryMatchingSearch(
    category: CategoryType,
    search: string,
): boolean {
    return (
        mapCategoryName({
            category,
            transactionDirection: TransactionDirectionType.incoming,
        })
            .toLowerCase()
            .includes(search.toLowerCase()) ||
        mapCategoryName({
            category,
            transactionDirection: TransactionDirectionType.outgoing,
        })
            .toLowerCase()
            .includes(search.toLowerCase())
    );
}

export function matchesCategorySearch(
    category: CategoryType,
    search: string,
): boolean {
    if (search.length === 0) {
        return true;
    }
    return (
        category.label.toLowerCase().includes(search.toLowerCase()) ||
        (category.description ?? "")
            .toLowerCase()
            .includes(search.toLowerCase()) ||
        isCategoryMatchingSearch(category, search)
    );
}
